import { useProgressCards } from "@features/dashboard/hooks/useProgressCards";
import LegacyReportDownload from "@features/report/components/print/LegacyReportDownload";
import { useLegacyReportDownload } from "@features/report/hooks/useLegacyReportDownload";
import { handleNavigateBack } from "@helpers/common";
import { useAppStore } from "@hooks/useAppStore";
import Box from "@memorang/ui/components/Box";
import { CustomAppBar } from "@memorang/ui/components/CustomAppbar";
import { LegacyTestsCard } from "@memorang/ui/components/ProgressApplet/LegacyTestsCard";
import ScrollContainer from "@memorang/ui/components/ScrollContainer";

const DetailedListLegacyTestsContainer = () => {
	const appFont = useAppStore((state) => state.app.font) || "opensans";
	const { data } = useProgressCards();
	const { downloadingId, handleDownload, clearDownload } =
		useLegacyReportDownload();
	const legacyTests = data.legacyTests;

	if (!legacyTests) {
		return null;
	}

	return (
		<>
			<CustomAppBar
				title={legacyTests.title}
				onPressBack={() => handleNavigateBack("/(protected)/(tabs)/progress")}
				hideCommandBar
			/>
			<Box flex={1}>
				<ScrollContainer
					maxWidth="sm"
					contentContainerStyle={{
						padding: 16,
					}}
				>
					<LegacyTestsCard
						{...legacyTests}
						appFont={appFont}
						handleDownload={handleDownload}
						downloadingId={downloadingId}
					/>
				</ScrollContainer>
			</Box>
			{downloadingId ? (
				<LegacyReportDownload
					sessionId={downloadingId}
					onDone={clearDownload}
				/>
			) : null}
		</>
	);
};

export default DetailedListLegacyTestsContainer;
